import styled from "styled-components";

export const Loading = styled.div`
  width: 100vw;
  height: 100vh;
  z-index: 10;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba( 120, 120, 120, 0.2 );
  box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
  backdrop-filter: blur( 5.5px );
  -webkit-backdrop-filter: blur( 5.5px );
  border-radius: 10px;
  border: 1px solid rgba( 255, 255, 255, 0.18 );
  top: 0;
  left: 0;
`

export const LoadingDiv = styled.div`
  width: 5rem;
  height: 5rem;
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  user-select: none;

  div{
    width: 50px;
    padding: 8px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: #0090D3;
    --_m: 
      conic-gradient(#0000 10%,#000),
      linear-gradient(#000 0 0) content-box;
    -webkit-mask: var(--_m);
            mask: var(--_m);
    -webkit-mask-composite: source-out;
            mask-composite: subtract;
    animation: l3 1s infinite linear;
    @keyframes l3 {to{transform: rotate(1turn)}}
  }
`